module.exports = __webpack_public_path__ + "static/media/top_18.a5c79292.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/images/top_18.svg
// module id = 244
// module chunks = 27